module.exports = __webpack_public_path__ + "img/diana_off.8f641a33.webp";